/* eslint-disable no-console */
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { dataFromSnapshot } from "../firestore/firestoreService";
import {
  asyncActionStart,
  asyncActionFinish,
  asyncActionError,
} from "../redux/data/async/asyncReducer";

export const useFirestoreCollection: any = ({
  query,
  data,
  deps,
  shouldExecute = true,
  local,
}: any) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!shouldExecute) return;
    if (!query()) return;
    !local && dispatch(asyncActionStart());
    const unsubscribe = query().onSnapshot(
      (snapshot: any) => {
        const docs = snapshot.docs.map((doc: any) => dataFromSnapshot(doc));
        local ? data(docs) : dispatch(data(docs));
        !local && dispatch(asyncActionFinish());
      },
      (error: any) => (local ? error : dispatch(asyncActionError(error)))
    );
    return () => {
      unsubscribe();
    };
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  }, deps);
};
